module.exports = __webpack_public_path__ + "static/media/care_device_zoom_in.b1f99bd7.svg";